// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"7e9d0856","498":"49b0a5c9","703":"781bc654"}[chunkId] + ".chunk.js";
};